import { sendBi } from '../../services/bi/send-request';
import { BIEventIds } from '../../services/bi/event-ids';
export const sendUploadCoverEvent = data => {
  sendBi('/mg', {
    src: 26,
    evid: BIEventIds.BIEventsIds.responseTime,
    call_name: 'boards.cover.upload',
    response_time: Math.round(data.responseTime || 0),
    response_size: Math.round(data.responseSize || 0),
    response_speed: data.responseTime > 0 && Math.round(data.responseSize / (data.responseTime / 1000)),
    result: data.isSuccess ? 'success' : 'fail'
  });
};
export const sendInvalidBoardItemEvent = data => {
  sendBi('/trg', {
    src: 26,
    evid: 10,
    cat: 15,
    // favorites/boards category
    sev: BIEventIds.severity.warning,
    errc: 'invalid_board_item',
    errn: 'boards.item.invalid_src_type',
    p1: data.srcType || 'unknown',
    p2: data.itemId || '',
    p3: data.boardId || '',
    dsc: `Invalid board item src_type: ${data.srcType}`
  });
};